/* ----------------------------------------
    App Configuration
---------------------------------------- */

const app = {
    api: process.env.VUE_APP_API,
};

/* ----------------------------------------
    Export Module
---------------------------------------- */

module.exports = {
    app
};